import React from 'react';

import ActivityWrapper from '../activity-wrapper/activity-wrapper';
import bounceRebookedActivityShape from '../../../../../shapes/bounce-rebooked-activity';
import { ACTIVITY_TYPES } from '../../../../../constants';
import { formatUsername } from '../../../../../utils/common';
import NoteSection from '../note-section/note-section';

/**
 * Bounce Activity Component
 * @param {object} params - Object containing props
 * @param {object} params.activity - Activity to display
 * @return {element}
 */
const ActivityBounce = ({ activity }) => {
  // Build header content
  const headerContent = [
    { text: `${formatUsername(activity.initiatorName)} bounced the carrier from the load` },
    { text: 'Bounced Carrier', descriptor: `${activity.carrierName}` },
    { text: 'Bounce Reason', descriptor: `${activity.reason}` }];

  return (
    <ActivityWrapper
      type={ACTIVITY_TYPES.bounce}
      headerContent={headerContent}
      timestamp={activity.eventTime}
      testId="activity-bounce"
    >
      <NoteSection note={activity.note} />
    </ActivityWrapper>
  );
};

ActivityBounce.propTypes = {
  activity: bounceRebookedActivityShape.isRequired,
};

export default ActivityBounce;
